import { useState } from "react";
import { partnershipSchema, type PartnershipPayload } from "@anton/shared";
import { PageHeader } from "../components/PageHeader";
import { Field } from "../components/Field";
import { SubmitButton } from "../components/SubmitButton";
import { SuccessScreen } from "../components/SuccessScreen";
import { Card, Lead, P, SectionHeader } from "../components/Section";
import { submitApplication } from "../lib/api";
import { haptic, showAlert } from "../lib/telegram";

export default function Partnership() {
  const [form, setForm] = useState<Partial<PartnershipPayload>>({});
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  if (done) return <SuccessScreen message="Предложение отправлено. Если зацепит — свяжемся." />;

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    const parsed = partnershipSchema.safeParse(form);
    if (!parsed.success) {
      const fe: Record<string, string> = {};
      for (const i of parsed.error.issues) fe[i.path.join(".")] = i.message;
      setErrors(fe);
      haptic("error");
      return;
    }
    setLoading(true);
    const res = await submitApplication("PARTNERSHIP", parsed.data);
    setLoading(false);
    if (!res.ok) { showAlert(res.error ?? "Ошибка"); haptic("error"); return; }
    setDone(true);
  }

  return (
    <div className="pb-10">
      <PageHeader
        eyebrow="Партнёрство"
        title="Идея, бартер или коллаборация?"
        subtitle="Расскажи без долгих прелюдий. Если зайдёт — свяжемся."
        icon="🤝"
        iconColor="yellow"
      />
      <div className="px-5 mt-3 space-y-3">
        <Card>
          <Lead>
            Партнёрства — это лучшее, что было в моих проектах за 18 лет в бизнесе.
            Если у тебя есть толковая идея — расскажи по делу.
          </Lead>
          <P>
            Не нужны длинные презентации и pitch-deck'и. Опиши идею, что хочешь от меня и что предлагаешь со своей стороны. Если зацепит — свяжемся в течение пары дней.
          </P>
        </Card>
      </div>

      <SectionHeader>Опиши предложение</SectionHeader>
      <form noValidate onSubmit={onSubmit} className="px-5 space-y-4">
        <Field label="Имя" error={errors["name"]}>
          <input className={`ios-input ${errors["name"] ? "ios-input-error" : ""}`}
            value={form.name ?? ""} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </Field>
        <Field label="Контакт" error={errors["contact"]}>
          <input className={`ios-input ${errors["contact"] ? "ios-input-error" : ""}`}
            value={form.contact ?? ""} onChange={(e) => setForm({ ...form, contact: e.target.value })}
            placeholder="Telegram / телефон / email" />
        </Field>
        <Field label="Описание предложения" error={errors["proposal"]}>
          <textarea rows={8} className={`ios-input ${errors["proposal"] ? "ios-input-error" : ""}`}
            value={form.proposal ?? ""} onChange={(e) => setForm({ ...form, proposal: e.target.value })}
            placeholder="Что предлагаешь и что хочешь взамен. Без воды, по делу." />
        </Field>
        <div className="pt-2">
          <SubmitButton loading={loading}>Отправить предложение</SubmitButton>
        </div>
      </form>
    </div>
  );
}
